import { computed, inject, Service, Signal } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { Router } from '@angular/router'
import { map, startWith } from 'rxjs'

import { RouteHeader } from './route-header'

/** URL actual como signal, para marcar el ítem activo de la navegación. */
@Service()
export class ActiveRoute {
  #router = inject(Router)

  readonly currentUrl = toSignal(
    this.#router.events.pipe(
      startWith(null),
      map(() => this.#router.url)
    ),
    { initialValue: this.#router.url }
  )

  /** Encabezado de la ruta activa más profunda; `undefined` si no declara uno. */
  readonly header = toSignal(
    this.#router.events.pipe(
      startWith(null),
      map(() => this.#header())
    ),
    { initialValue: this.#header() }
  )

  /** La raíz exige coincidencia exacta; el resto compara por prefijo. */
  isActive(route: string): boolean {
    const currentUrl = this.currentUrl()
    if (route === '/') return currentUrl === '/'

    return currentUrl?.startsWith(route) ?? false
  }

  isActiveSignal(route: string): Signal<boolean> {
    return computed(() => this.isActive(route))
  }

  #header(): RouteHeader | undefined {
    let route = this.#router.routerState.snapshot.root
    while (route.firstChild) route = route.firstChild

    return route.data['header'] as RouteHeader | undefined
  }
}
